import { useEffect } from "react"
import { useGuias } from "../context/GuiasContext"
import QRCode from "qrcode"

export default function AutoDownloadGuia() {
  const { guias, logoUrl, dadosPrefeitura } = useGuias()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const guiaId = params.get("guia")

    if (guiaId && guias.length > 0) {
      const guia = guias.find(g => g._id === guiaId)

      if (guia && dadosPrefeitura) {
        const guiaUrl = `${window.location.origin}${window.location.pathname}?guia=${guia._id}`

        QRCode.toDataURL(guiaUrl, {
          width: 100,
          margin: 1,
          color: { dark: "#004161", light: "#FFFFFF" }
        }).then((qrCodeUrl) => {
          // Formatar datas com segurança
          const fmtDate = (d?: string) => {
            if (!d) return "Não informada"
            try { return new Date(d).toLocaleDateString("pt-BR") } catch { return d }
          }

          // HTML da página 1 — documento da guia
          const paginaGuia = `
            <div style="padding:20px 25px;font-family:Arial,sans-serif;font-size:12px;color:#111;">
              <!-- Cabeçalho -->
              <div style="display:flex;gap:12px;align-items:flex-start;margin-bottom:10px;padding-bottom:10px;border-bottom:2px solid #004161;">
                <img src="${logoUrl}" alt="Logo" style="height:60px;width:auto;object-fit:contain;" />
                <div style="flex:1;">
                  <div style="font-size:15px;font-weight:bold;color:#004161;">${dadosPrefeitura.nomePrefeitura}</div>
                  <div style="font-size:11px;color:#333;">${dadosPrefeitura.secretaria}</div>
                  <div style="font-size:11px;color:#333;">${dadosPrefeitura.departamento}</div>
                  <div style="font-size:10px;color:#555;margin-top:2px;">${dadosPrefeitura.endereco} | CEP: ${dadosPrefeitura.cep}</div>
                  <div style="font-size:10px;color:#555;">CNPJ: ${dadosPrefeitura.cnpj} | Tel: ${dadosPrefeitura.telefone}</div>
                </div>
              </div>

              <h3 style="text-align:center;font-size:14px;font-weight:bold;text-transform:uppercase;color:#004161;margin:8px 0 12px;">
                GUIA DE SEPULTAMENTO Nº ${guia.numero}
              </h3>

              <!-- Falecido -->
              <div style="margin-bottom:10px;">
                <div style="font-size:12px;font-weight:bold;color:#004161;border-bottom:1px solid #ccc;margin-bottom:5px;padding-bottom:2px;">Informações do Falecido</div>
                <table style="width:100%;border-collapse:collapse;">
                  <tr>
                    <td style="width:50%;padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Nome Completo:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.nomeFalecido || ""}</div>
                    </td>
                    <td style="width:50%;padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Data de Nascimento:</div>
                      <div style="font-size:11px;font-weight:500;">${fmtDate(guia.dataNascimento)}</div>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Idade:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.idade || ""} anos</div>
                    </td>
                    <td style="padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Nome da Mãe:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.nomeMae || ""}</div>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Nome do Pai:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.nomePai || ""}</div>
                    </td>
                    <td style="padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Naturalidade:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.naturalidade || ""}</div>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Cor:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.cor || ""}</div>
                    </td>
                    <td></td>
                  </tr>
                </table>
              </div>

              <!-- Óbito -->
              <div style="margin-bottom:10px;">
                <div style="font-size:12px;font-weight:bold;color:#004161;border-bottom:1px solid #ccc;margin-bottom:5px;padding-bottom:2px;">Informações do Óbito</div>
                <table style="width:100%;border-collapse:collapse;">
                  <tr>
                    <td style="width:50%;padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Causa da Morte:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.causaMorte || ""}</div>
                    </td>
                    <td style="width:50%;padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Local do Óbito:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.localObito || ""}</div>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Data do Óbito:</div>
                      <div style="font-size:11px;font-weight:500;">${fmtDate(guia.dataObito)}</div>
                    </td>
                    <td style="padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Hora do Óbito:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.horaObito || ""}</div>
                    </td>
                  </tr>
                </table>
              </div>

              <!-- Sepultamento -->
              <div style="margin-bottom:10px;">
                <div style="font-size:12px;font-weight:bold;color:#004161;border-bottom:1px solid #ccc;margin-bottom:5px;padding-bottom:2px;">Informações do Sepultamento</div>
                <table style="width:100%;border-collapse:collapse;">
                  <tr>
                    <td style="width:50%;padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Óbito Nº:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.obitoNumero || ""}</div>
                    </td>
                    <td style="width:50%;padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Fls:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.fls || ""}</div>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Livro Nº:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.livroNumero || ""}</div>
                    </td>
                    <td style="padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Cartório:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.cartorio || ""}</div>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Data do Sepultamento:</div>
                      <div style="font-size:11px;font-weight:500;">${fmtDate(guia.dataSepultamento)}</div>
                    </td>
                    <td style="padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Cemitério:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.cemiterio || ""}</div>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Valor Pago:</div>
                      <div style="font-size:11px;font-weight:500;">R$ ${guia.valorPago || ""}</div>
                    </td>
                    <td style="padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Conforme Talão Nº:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.talaoNumero || ""}</div>
                    </td>
                  </tr>
                </table>
              </div>

              <!-- Solicitante -->
              <div style="margin-bottom:12px;">
                <div style="font-size:12px;font-weight:bold;color:#004161;border-bottom:1px solid #ccc;margin-bottom:5px;padding-bottom:2px;">Informações do Solicitante</div>
                <table style="width:100%;border-collapse:collapse;">
                  <tr>
                    <td style="width:50%;padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">Nome do Solicitante:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.nomeSolicitante || ""}</div>
                    </td>
                    <td style="width:50%;padding:2px 4px;vertical-align:top;">
                      <div style="font-size:10px;color:#666;">CPF:</div>
                      <div style="font-size:11px;font-weight:500;">${guia.cpfSolicitante || ""}</div>
                    </td>
                  </tr>
                </table>
              </div>

              <!-- Assinaturas -->
              <table style="width:100%;border-collapse:collapse;margin-top:20px;">
                <tr>
                  <td style="width:50%;text-align:center;padding:0 20px;">
                    <div style="border-top:1px solid #999;padding-top:5px;">
                      <div style="font-size:11px;font-weight:500;">Assinatura do Responsável</div>
                      <div style="font-size:9px;color:#666;">Secretaria Municipal</div>
                    </div>
                  </td>
                  <td style="width:50%;text-align:center;padding:0 20px;">
                    <div style="border-top:1px solid #999;padding-top:5px;">
                      <div style="font-size:11px;font-weight:500;">Assinatura do Solicitante</div>
                      <div style="font-size:9px;color:#666;">${guia.nomeSolicitante || ""}</div>
                    </div>
                  </td>
                </tr>
              </table>

              <!-- Rodapé + QR Code -->
              <div style="margin-top:16px;text-align:center;font-size:9px;color:#888;">
                <div>Documento emitido em ${new Date().toLocaleDateString("pt-BR")} às ${new Date().toLocaleTimeString("pt-BR")}</div>
                <div style="margin-top:8px;">
                  <div style="font-size:9px;color:#888;margin-bottom:4px;">Escaneie para baixar o PDF</div>
                  <img src="${qrCodeUrl}" alt="QR Code" style="width:80px;height:80px;" />
                </div>
              </div>
            </div>
          `

          // Página 2 — anexo (certidão), separada por quebra de página explícita
          let paginaAnexo = ""
          if (guia.certidaoBase64) {
            if (guia.certidaoBase64.startsWith("data:application/pdf")) {
              // PDF: iframe em vez de embed — embed com data: URI é bloqueado na impressão em browsers modernos
              paginaAnexo = `
                <div class="pagina-anexo" style="page-break-before:always;break-before:page;display:block;width:100%;height:297mm;margin:0;padding:0;overflow:hidden;">
                  <div style="font-size:13px;font-weight:bold;color:#004161;text-align:center;padding:8px 0 6px;">Certidão de Óbito Anexada</div>
                  <iframe src="${guia.certidaoBase64}" style="width:100%;height:calc(297mm - 34px);border:none;display:block;" frameborder="0"></iframe>
                </div>
              `
            } else {
              // Imagem: contida na página, sem corte
              paginaAnexo = `
                <div class="pagina-anexo" style="page-break-before:always;break-before:page;display:block;width:100%;min-height:200mm;margin:0;padding:20px;text-align:center;box-sizing:border-box;">
                  <div style="font-size:13px;font-weight:bold;color:#004161;margin-bottom:12px;">Certidão de Óbito Anexada</div>
                  <img
                    src="${guia.certidaoBase64}"
                    alt="Certidão de Óbito"
                    style="max-width:100%;max-height:240mm;height:auto;width:auto;border:1px solid #ccc;object-fit:contain;display:block;margin:0 auto;"
                  />
                </div>
              `
            }
          }

          // Abrir janela isolada e imprimir
          const printWindow = window.open("", "_blank", "width=900,height=700")
          if (!printWindow) {
            alert("Por favor, permita popups neste site para efectuar o download do PDF.")
            return
          }

          printWindow.document.write(`
            <!DOCTYPE html>
            <html lang="pt-BR">
              <head>
                <meta charset="UTF-8" />
                <title>Guia de Sepultamento - ${guia.numero}</title>
                <style>
                  * { box-sizing: border-box; margin: 0; padding: 0; }
                  html, body { background: white; font-family: Arial, sans-serif; }
                  @page { size: A4 portrait; margin: 10mm; }
                  @page :first { margin: 10mm; }
                  @media print {
                    body { margin: 0; }
                    * {
                      -webkit-print-color-adjust: exact !important;
                      print-color-adjust: exact !important;
                    }
                    .pagina-guia { page-break-after: always; break-after: page; }
                    .pagina-anexo { page-break-before: always; break-before: page; }
                    iframe { -webkit-print-color-adjust: exact !important; }
                  }
                </style>
              </head>
              <body>
                <div class="pagina-guia">
                  ${paginaGuia}
                </div>
                ${paginaAnexo}
                <script>
                  window.onload = function() {
                    setTimeout(function() {
                      window.print()
                      setTimeout(function() {
                        if (window.opener) window.close()
                      }, 1500)
                    }, 800)
                  }
                <\/script>
              </body>
            </html>
          `)
          printWindow.document.close()
        }).catch((error) => {
          console.error("Erro ao gerar QR Code:", error)
        })
      }
    }
  }, [guias, logoUrl, dadosPrefeitura])

  return null
}
